import React from "react";
import PropTypes from 'prop-types';

import './FibrePackageDetails.css';
import DownloadSpeedIcon from "../Svg/DownloadSpeedIcon"
import UploadSpeedIcon from "../Svg/UploadSpeedIcon"
import DataSizeIcon from "../Svg/DataSizeIcon"
import { isMobileView } from "../../../Utility/utility";

const FibrePackageDetails = (props) => {
    const downloadSpeed = props.speed.slice(0, -4).split("/")[0];
    const uploadSpeed = props.speed.slice(0, -4).split("/")[1];
    const dataSize = props.type === "Fibre uncapped" ? "Uncapped" : props.type;

    return (
        <React.Fragment>
            <div className="fibrePackageDetailsWrapper" automationid="SalesLeads_Div_FibrePackageDetailsWrapper_0">
                <div className="fibrePackageDetailsItems" automationid="SalesLeads_Div_FibrePackageDetailsItems_1">
                {
                    isMobileView() ?
                    <div className="fibrePackageDetailsItems" automationid="SalesLeads_Div_FibrePackageDetailsItems_2">
                        <div className="fibrePackageDetailsItemRow" automationid="SalesLeads_Div_FibrePackageDetailsItemRow_3">
                            <div className="fibrePackageDetailsItem" automationid="SalesLeads_Div_FibrePackageDetailsItem_4">
                                <div className="fibrePackageDetailsItemIcon" automationid="SalesLeads_Div_FibrePackageDetailsItemIcon_5">
                                    <DownloadSpeedIcon></DownloadSpeedIcon>
                                    <p className="fibrePackageDetailsItemTitle" automationid="SalesLeads_P_FibrePackageDetailsItemTitle_0">{downloadSpeed}Mbps</p>
                                </div>
                                <p className="fibrePackageDetailsItemDetails" automationid="SalesLeads_P_FibrePackageDetailsItemDetails_1">Download speed</p>
                            </div>
                            <div className="fibrePackageDetailsItem" automationid="SalesLeads_Div_FibrePackageDetailsItem_6">
                                <div className="fibrePackageDetailsItemIcon" automationid="SalesLeads_Div_FibrePackageDetailsItemIcon_7">
                                    <DataSizeIcon></DataSizeIcon>
                                    <p className="fibrePackageDetailsItemTitle" automationid="SalesLeads_P_FibrePackageDetailsItemTitle_2">{dataSize}</p>
                                </div>
                                <p className="fibrePackageDetailsItemDetails" automationid="SalesLeads_P_FibrePackageDetailsItemDetails_3">Data size</p>
                            </div>
                        </div>
                        <div className="fibrePackageDetailsItem" automationid="SalesLeads_Div_FibrePackageDetailsItem_8">
                            <div className="fibrePackageDetailsItemIcon" automationid="SalesLeads_Div_FibrePackageDetailsItemIcon_9">
                                <UploadSpeedIcon></UploadSpeedIcon>
                                <p className="fibrePackageDetailsItemTitle" automationid="SalesLeads_P_FibrePackageDetailsItemTitle_4">{uploadSpeed}Mbps</p>
                            </div>
                            <p className="fibrePackageDetailsItemDetails" automationid="SalesLeads_P_FibrePackageDetailsItemDetails_5">Upload speed</p>
                        </div>
                    </div>

                    :

                    <div className="fibrePackageDetailsItems" automationid="SalesLeads_Div_FibrePackageDetailsItems_2">
                        <div className="fibrePackageDetailsItem" automationid="SalesLeads_Div_FibrePackageDetailsItem_3">
                            <div className="fibrePackageDetailsItemIcon" automationid="SalesLeads_Div_FibrePackageDetailsItemIcon_4">
                                <DownloadSpeedIcon></DownloadSpeedIcon>
                                <p className="fibrePackageDetailsItemTitle" automationid="SalesLeads_P_FibrePackageDetailsItemTitle_0">{downloadSpeed}Mbps</p>
                            </div>
                            <p className="fibrePackageDetailsItemDetails" automationid="SalesLeads_P_FibrePackageDetailsItemDetails_1">Download speed</p>
                        </div>
                        <div className="fibrePackageDetailsItem" automationid="SalesLeads_Div_FibrePackageDetailsItem_5">
                            <div className="fibrePackageDetailsItemIcon" automationid="SalesLeads_Div_FibrePackageDetailsItemIcon_6">
                                <UploadSpeedIcon></UploadSpeedIcon>
                                <p className="fibrePackageDetailsItemTitle" automationid="SalesLeads_P_FibrePackageDetailsItemTitle_2">{uploadSpeed}Mbps</p>
                            </div>
                            <p className="fibrePackageDetailsItemDetails" automationid="SalesLeads_P_FibrePackageDetailItemDetailss_3">Upload speed</p>
                        </div>
                        <div className="fibrePackageDetailsItem" automationid="SalesLeads_Div_FibrePackageDetailsItem_7">
                            <div className="fibrePackageDetailsItemIcon" automationid="SalesLeads_Div_FibrePackageDetailsItemIcon_8">
                                <DataSizeIcon></DataSizeIcon>
                                <p className="fibrePackageDetailsItemTitle" automationid="SalesLeads_P_FibrePackageDetailsItemTitle_4">{dataSize}</p>
                            </div>
                            <p className="fibrePackageDetailsItemDetails" automationid="SalesLeads_P_FibrePackageDetailsItemDetails_5">Data size</p>
                        </div>
                    </div>
                }
                </div>
            </div>
        </React.Fragment>
    )
}

FibrePackageDetails.propTypes = {
    speed: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};

export default FibrePackageDetails;